export default __webpack_public_path__ + "static/media/logo-horizontal-stacked.f25a6901.png";